module.exports = __webpack_public_path__ + "img/014.5a91eddc.jpg";